import React, { createContext, useContext, useState, useCallback } from "react";
import Toast from "./Toast.jsx";
import "./ToastContext.scss"

const ToastContext = createContext();

export function ToastProvider({
  children,
  position = "bottom-center",
  maxToasts = 4
}) {
  const [toasts, setToasts] = useState([]);

  // Show a toast with duration parameter
  const showToast = useCallback((message, type = "info", duration = 5000) => {
    const id = Date.now() + Math.random();

    setToasts((prev) => {
      const next = [...prev, { id, message, type, duration, isClosing: false }];

      // limit total visible toasts
      if (next.length > maxToasts) next.shift();

      return next;
    });

    return id; // for programmatic closing
  }, [maxToasts]);

  // Close a toast (manual or programmatic)
  const closeToast = useCallback((id) => {
    // trigger fade-out animation
    setToasts((prev) =>
      prev.map((t) =>
        t.id === id ? { ...t, isClosing: true } : t
      )
    );

    // remove fully after animation delay
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, 300);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast, closeToast }}>
      {children}

      <div className={`toast-wrapper ${position}`}>
        {toasts.map((t) => (
          <Toast
            key={t.id}
            {...t}
            onClose={() => closeToast(t.id)}
          />
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export const useToast = () => useContext(ToastContext);
